import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
// common
import { computed, defineComponent, reactive, ref } from "vue";
import { useI18n } from "vue-i18n"; // modules

import UserModule from "@/store/modules/user";
import ModalModule from "@/store/modules/modal"; //helpers

import { convertCodeToIdLang } from "@/utils/helpers/lang";
import { ModalStatus } from "@/constants/modal";
export default defineComponent({
  name: "UserInfo",
  components: {},
  setup: function setup() {
    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var form = ref();
    var user = computed(function () {
      return UserModule.getUser || {};
    });
    var ruleForm = reactive({
      firstName: user.value.firstName,
      lastName: user.value.lastName,
      languageId: convertCodeToIdLang(user.value.language.code),
      languageCode: user.value.language.code
    });
    var rules = reactive({
      firstName: [{
        required: true,
        message: t("field.first-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.first-name-min-max"),
        trigger: "change"
      }],
      lastName: [{
        required: true,
        message: t("field.last-name-empty"),
        trigger: "change"
      }, {
        max: 45,
        min: 2,
        message: t("field.last-name-min-max"),
        trigger: "change"
      }],
      languageId: {
        required: true,
        message: t("field.language-empty"),
        trigger: "change"
      }
    });

    var submitForm = function submitForm() {
      if (!form.value) return;
      form.value.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 3;
                  return UserModule.patchInfo(ruleForm);

                case 3:
                  _context.next = 5;
                  return UserModule.fetchUser();

                case 5:
                  ModalModule.setStatus(ModalStatus.Hidden);
                  console.log("submit!");
                  _context.next = 11;
                  break;

                case 9:
                  console.log("error submit!");
                  return _context.abrupt("return", false);

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    };

    return {
      form: form,
      ruleForm: ruleForm,
      rules: rules,
      submitForm: submitForm
    };
  }
});